// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 4.5C13.2426 4.5 14.25 3.49264 14.25 2.25C14.25 1.00736 13.2426 0 12 0C10.7574 0 9.75 1.00736 9.75 2.25C9.75 3.49264 10.7574 4.5 12 4.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.75 7V5.5H2.25V7L8.75 8.75L9 12L4.75 22.75L6.25 23.5L11.995 14.5H12.005L17.75 23.5L19.25 22.75L15 12L15.25 8.75L21.75 7Z"}}]};

const AccessibilityFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'accessibility-filled',
    ref,
    icon: element,
  },
));

AccessibilityFilledIcon.displayName = 'AccessibilityFilledIcon';

export default AccessibilityFilledIcon;
